/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Exithelper1Inputs */

const en_questionnaire_exithelper1 = /** @type {(inputs: Questionnaire_Exithelper1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to home page`)
};

const fr_questionnaire_exithelper1 = /** @type {(inputs: Questionnaire_Exithelper1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retourner sur la page d'accueil`)
};

/**
* | output |
* | --- |
* | "Return to home page" |
*
* @param {Questionnaire_Exithelper1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_exithelper1 = /** @type {((inputs?: Questionnaire_Exithelper1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Exithelper1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_exithelper1(inputs)
	return fr_questionnaire_exithelper1(inputs)
});
export { questionnaire_exithelper1 as "questionnaire_exitHelper" }